import { render, staticRenderFns } from "./stdrate.vue?vue&type=template&id=2af42ff6&scoped=true&"
import script from "./stdrate.vue?vue&type=script&lang=js&"
export * from "./stdrate.vue?vue&type=script&lang=js&"
import style0 from "./stdrate.vue?vue&type=style&index=0&id=2af42ff6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af42ff6",
  null
  
)

export default component.exports